<template>
	<el-dialog :visible.sync="showwin" title="修改增值服务" width="550px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
		<div style="min-height:200px;" class="addedservice_order">
			<addedservice ref="addedservice"></addedservice>
		</div>
		<span slot="footer" class="dialog-footer">
			 <div style="text-align: center;">
				 <el-button type="success" @click="saveservice" size="mini">确 定</el-button>
				 <el-button @click="showwin=false" size="mini">取 消</el-button>
			 </div>
		 </span>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
import addedservice from '@/components/baseinfo/addedservice.vue';
export default {
	components: {
		addedservice
	},
	props: {
	},
	data() {
		return {
			showwin:false,
			p_pkval:'',
			q_id:'',
			userid:localStorage.getItem('userid')
		}
	},
	mounted() {
		
	},
	methods: {
		//加载服务
		init(param){
			this.p_pkval='';
			if(this.$refs.addedservice!=undefined){
				this.$refs.addedservice.servicelist=[];
			}
			if(param.p_pkval!=undefined){
				this.p_pkval=param.p_pkval;
			}
			this.showwin=true;
			//根据订单信息判断订单是否可以提交增值服务
			this.getorderinfo();
		},
		getorderinfo(){
			var that=this;
			this.$tool.loading('正在加载', 'addedservice_order');
			this.$apipost.get.GetOrderInfo({ pkval: this.p_pkval}).then(res => {
				this.$tool.loadingclose();
				if(res.orderinfo!=undefined){
					if(res.orderinfo.main!=undefined){
						var intercept=res.orderinfo.main.intercept;
						if(intercept!=undefined)
						{
							that.q_id=intercept.split('★')[0];
							if(that.q_id!=undefined){
								that.q_id=that.q_id.replace('服务单号：','').replace(',','');
							}
						}
					}
					var addedservice=res.orderinfo.extend.addedservice;
					if(addedservice==undefined)
						addedservice='';
					if(addedservice!='')
						addedservice=JSON.stringify(addedservice);
					setTimeout(function(){
						if(that.$refs.addedservice!=undefined){
							that.$refs.addedservice.init({p_pkval:that.p_pkval,vertical:false,loadall:true,changeresult:false,servicelist:addedservice});
						}
					},1000);
				}
				else
					this.$tool.message(res.message, 0);
			});
		},
		
		//保存服务
		saveservice(){
			var selecteditem=this.$refs.addedservice.servicelist.filter(function(e){return e.ischecked==true});
			if(selecteditem.length==0){
				selecteditem='';
			}
			var that=this;
			var paraminfo={
				userid:localStorage.getItem('userid'),
				servicelist:selecteditem,
				pkval:this.p_pkval,
				q_id:this.q_id,
				type:2 //内部人员修改增值服务
			}
			this.$tool.loading('正在保存', 'addedservice_order');
			this.$apipost.post.SaveOrderService({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if(res.state=='1')
					{
						this.$tool.message('保存成功', 1);
						that.showwin=false;
					}else{
						this.$tool.message(res.message, 0);
					}
				}
			});
		}
	}
}
	
</script>

